<template>
  <div class="syj_BlackfirstPrize syj_bg">
    <title class="commom-title"><span>一等奖</span></title>
    <div class="oneprize-content syj_page-width">
      <div class="syj_border-linear"></div>
      <div class="bgwhite">
        <div class="money">￥{{ fristprizemoney }}</div>
        <div v-if="fristprizemoney == 0" class="lunkong">
          很遗憾，该奖项轮空啦～
        </div>
        <ul
            class="winner-list"
            :class="blackresultlist.length > 1 ? 'col-2' : ''"
        >
          <li
              class="winner-item"
              v-for="(item, index) in blackresultlist"
              :key="index"
          >
            <div class="avatar">
              <img :src="item.avatar_url" />
            </div>
            <div class="info">
              <div class="row">
                <div class="name">{{ item.name }}</div>
                <div class="number-info">
                  <span class="title">中奖号码</span>
                  <span class="number">{{ item.award_number }}</span>
                </div>
              </div>
              <div class="commitment">{{ item.order_commitment }}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "firstPrize",
  // data() {
  //   return {
  //     fristprizemoney: "￥5,600",
  //     blackresultlist: [
  //       { resultname: "jenny", resultnumber: 124567 - 0 },
  //       { resultname: "孙艳杰", resultnumber: 124588 - 9 },
  //     ],
  //   };
  // },
  props: {
    fristprizemoney: {
      type: [Number, String],
      default: ""
    },
    blackresultlist: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
  },
  methods: {},
};
</script>
<style scoped lang="less">
@import "./style.less";

.winner-item {
  .info {
    .name {
      color: #0a0a0a;
    }
    
    .number-info {
      color: #0a0a0a;
    }
    
    .commitment {
      color: #777;
    }
  }
}
</style>
<style lang="less">

.syj_BlackfirstPrize {
  .bgwhite {
    background: #fff;
    padding: 30px 0;
  }
  
  .lunkong {
    color: #000;
    width: 100%;
    justify-content: center;
    margin-top: 20px;
  }
  
  .oneprize-content {
    padding: 10px;
    margin-top: 15px;
  }
  
  .money {
    background: url("https://maiyuan-zhusun.oss-cn-hangzhou.aliyuncs.com/upload/resultprize-bg2.png") no-repeat top center;
    height: 112px;
    font-size: 54px;
    color: #fff;
    font-weight: 600;
    padding-left: 8px;
    line-height: 114px;
  }
}
</style>
